import { Pencil } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import FormUpdateCaisse from './FormUpdateCaisse';
import { useAlert, Spin, Input, Button, IconButton } from '../ui';
import FormDrawer from '../ui/FormDrawer';
import Message from '../Message';
import { useAuthHeader, useAuthUser } from 'react-auth-kit';
import User from '../../Models/User';
import env from 'react-dotenv';
import datas from "../../Assets/data.json";
import { Crypter } from '../../Functions/Security/Crypter';
import axios from 'axios';

export default function EditNumCaisse(props: { reccord?: any, handleFunction?: any }) {
    // USER TOKEN
    const authHeader = useAuthHeader()

    const [open, setOpen] = React.useState(false);
    const [isOk, setIsOk] = useState<boolean>(false)
    const [fichier, setFicher] = useState<File>()
    const [loading, setLoading] = useState<boolean>(false)

    const auth = useAuthUser()
    const user: User = JSON.parse(JSON.stringify(auth() || {}))
    const alert = useAlert();

    const { register, handleSubmit, setValue, reset } = useForm()

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        props.handleFunction()
    };

    useEffect(() => {
        //setValue("NumBox", "")
        setValue("CodeU", props.reccord.CodeU)
        setValue("Name", props.reccord.Name)
        setValue("NumBox", props.reccord.NumBox)
    })

    const onSubmit = async (data: any) => {
        setLoading(true)

        let config = {
            method: 'put',
            maxBodyLength: Infinity,
            url: env.API_BASE_URL + datas.API_LINKs.Affectation,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authHeader(),
            },
            data: Crypter.encrypt(JSON.stringify({ "CodeU": data.CodeU, "Numero": data.NumBox, "CodeS": user.CodeS, "CodeFiliale": user.CodeFiliale, "CodeAbonne": user.CodeAbonne, "CreatedBy": user.CodeU }))
        }

        axios.request(config)
            .then((response) => {
                setLoading(false)
                const res = JSON.parse(Crypter.decrypt(response.data)).Value
                if (res.StatutCode == 200) {
                    alert.success(res.Message)
                    setValue("NumBox", data.NumBox)
                    reset()
                    props.handleFunction()
                    setOpen(false)
                } else {
                    alert.warning(res.Message)
                }

            })
            .catch((error) => {
                setLoading(false)
                alert.error(error.message)
            });

    }

    setTimeout(() => {
        try {
            let sendOpe = localStorage.getItem("sendOpe")
            if (sendOpe == "1") {
                setOpen(false)
                localStorage.removeItem("sendOpe")
            }
        } catch (error) {

        }

    }, .1);



    return (
        <div>
            <IconButton onClick={handleClickOpen} color='primary' size={32}><Pencil size={16} /></IconButton>
            <FormDrawer
                open={open}
                onClose={handleClose}
                title="Modifier la caissière"
                hint="Modifiez le numéro de caisse associé à cette caissière."
            >
                    <>
                        <Spin spinning={loading}>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className='round0'>{/*className='round0'*/}
                                    <div className='ressource'>
                                        <div className="flex gap-3">
                                            <Input
                                                onKeyUp={() => setIsOk(false)}
                                                {...register("NumBox")}
                                                className='input'
                                                required
                                                type='text'
                                                label={'Numéro de caisse'}
                                                placeholder={"Saisissez le Numéro de caisse"} />
                                            <Input
                                                disabled
                                                onKeyUp={() => setIsOk(false)}
                                                {...register("CodeU")}
                                                className='input'
                                                required
                                                type='tel'
                                                label={'Code Utilisateur'}
                                                placeholder={"Saisissez le Code Utilisateur"} />
                                        </div>
                                        <br />
                                        <div className="flex">
                                            <Input
                                                disabled
                                                onKeyUp={() => setIsOk(false)}
                                                {...register("Name")}
                                                className='input'
                                                required
                                                type='text'
                                                label={'Nom Utilisateur'}
                                                placeholder={"Saisissez le Nom Utilisateur"} />
                                        </div>
                                        <br /><br />
                                        <Button className='w-full' variant='success' type='submit'>Enregistrer</Button>

                                    </div>
                                </div>
                                {isOk ? <div><br /><Message messageAlert={'Saved'} type='success' /></div> : ""}

                            </form>
                        </Spin>
                    </>
            </FormDrawer>
        </div>
    );
}
